<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{ params: any }>()
const router = useRouter()

const href = computed(() => {
  const uuid = props.params?.data?.uuid
  return uuid ? `/dashboard/regulation/${uuid}` : null
})

function onClick(e: MouseEvent) {
  if (!href.value) return
  e.preventDefault()
  if (e.ctrlKey || e.metaKey) {
    window.open(href.value, '_blank')
  } else {
    router.push(href.value)
  }
}
</script>

<template>
  <div class="flex items-center gap-2 flex-wrap">
    <a
      v-if="href"
      :href="href"
      class="btn btn-sm btn-ghost"
      @click="onClick"
    >Voir</a>
  </div>
</template>
